import { requestFunnel } from '@/application/api';
import { authenticationService } from '@/application/services/api-clients/login-service';

const getOptions = () => ({ headers: authenticationService.authHeader() });

export const getInvestors = async () => {
  const response = await requestFunnel.get('investors/names', getOptions());
  return response.data;
};

export const getInvestorsByUser = async userId => {
  const response = await requestFunnel.get(`user/${userId}/investors`, getOptions());
  return response.data;
};
